/**
 * Preferências guardadas no navegador antes do nome Hive (chaves "one.*": tema, idioma, colunas, rascunhos dos
 * assistentes...) passam para as chaves atuais ("hive.*") na primeira abertura, sem a pessoa perder nada. A chave
 * atual vence quando as duas existem; a antiga sai depois de copiada.
 */
export const LEGACY_PREFIX = 'one.';
export const STORAGE_PREFIX = 'hive.';

function migrate(store: Storage | undefined) {
  if (!store) return;
  const old: string[] = [];
  for (let i = 0; i < store.length; i++) {
    const k = store.key(i);
    if (k?.startsWith(LEGACY_PREFIX)) old.push(k);
  }
  for (const k of old) {
    const now = STORAGE_PREFIX + k.slice(LEGACY_PREFIX.length);
    const v = store.getItem(k);
    if (store.getItem(now) === null && v !== null) store.setItem(now, v);
    store.removeItem(k);
  }
}

export function migrateLegacyStorage() {
  for (const get of [() => window.localStorage, () => window.sessionStorage]) {
    try {
      migrate(get());
    } catch {
      /* sem armazenamento (modo privado, bloqueado): nada a migrar */
    }
  }
}

// roda ao carregar o pacote, antes de qualquer tela ler as preferências
if (typeof window !== 'undefined') migrateLegacyStorage();
